import { useEffect, useState } from "react";
import { getFromStorage } from "../guards/Encrypt";
import { USER_PERMISSIONS } from "../constants/user-permissions";

export const useAuthentication = () => {
    const storedUserData = getFromStorage('user');
    const storedTokenData = localStorage.getItem('token');
    const initialToken = storedTokenData ? true : false;
    const initialType = storedUserData?.rol || "";
    const initialMail = storedUserData?.correo || "";
    const initialName = storedUserData?.nombre || "";
    const initalIdUser = storedUserData?.id || "";
    const initialEspecialidad = storedUserData?.especialidad || "";

    const [isAuthenticated, setIsAuthenticated] = useState(initialToken);
    const [userRole, setUserRole] = useState(initialType);
    const [userMail, setUserMail] = useState(initialMail);
    const [userName, setUserName] = useState(initialName);
    const [idUser, setIdUser] = useState(initalIdUser);
    const [especialidad, setEspecialidad] = useState(initialEspecialidad);

    useEffect(() => {
        let previousUser = getFromStorage('user');
        let previousToken = localStorage.getItem('token');

        const checkAuth = () => {
            const currentUser = getFromStorage('user');
            const currentToken = localStorage.getItem('token');

            if (previousUser !== currentUser || previousToken !== currentToken) {
                setIsAuthenticated(!!currentToken);
                setUserRole(currentUser?.rol || "");
                setUserMail(currentUser?.correo || "");
                setUserName(currentUser?.nombre || "");
                setIdUser(currentUser?.id || "");
                setEspecialidad(currentUser?.especialidad || "");

                // Forzar logout si el rol no es válido
                if (!USER_PERMISSIONS[currentUser?.rol]) {
                    localStorage.clear();
                    window.location.href = '/login';
                }

                // Actualizar los valores previos
                previousUser = currentUser;
                previousToken = currentToken;
            }
        };

        const intervalId = setInterval(checkAuth, 1000); // Verifica cada segundo

        return () => clearInterval(intervalId);
    }, []);

    return { isAuthenticated, userRole, userMail, userName, idUser, especialidad };
};